import { Button, Flex, Skeleton } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { IFilePath } from 'src/types/helpdesk/topic.type';
import MessageImageContainer from '../Message/MessageImage/MessageImageContainer';
import './Attachment.scss';
import Dropdown from 'antd/es/dropdown/dropdown';
import More from 'src/assets/icons/more2.png';
import { TopicContext } from 'src/contexts/topic.context';
import useDownload from 'src/hooks/useDownload';
import Icon from 'src/components/v2/Icon';
import { scrollToReply } from 'src/utils/utils';

type Props = {
  files: IFilePath[];
  loading: boolean;
};

const LIMIT = 3;

export default function TopicAttachmentFile({ files: filesData, loading }: Props) {
  const [files, setFiles] = useState<IFilePath[]>([]);
  const [isShow, setIsShow] = useState<boolean>(false);
  const download = useDownload();
  const { currentTopicMessagesGroup, setPage } = useContext(TopicContext);
  useEffect(() => {
    if (filesData && !isShow) {
      setFiles(filesData.slice(0, LIMIT));
    } else {
      setFiles(filesData);
    }
  }, [filesData, isShow]);

  const handleShowAll = () => {
    setFiles(filesData);
    setIsShow(true);
  };
  const handleShowLess = () => {
    setFiles(filesData.slice(0, LIMIT));
    setIsShow(false);
  };

  const handleScrollToOrigin = (topicDetailId: string) => {
    const index = currentTopicMessagesGroup?.findIndex((x) => x?.id === topicDetailId);
    const pageOfIndex = Math.ceil((index || 0) / 10);
    setPage((prev) => {
      if (pageOfIndex > prev) {
        return pageOfIndex;
      }
      return prev;
    });

    scrollToReply(String(topicDetailId), 'center');
  };

  const handleDownload = (image: IFilePath) => {
    download.download(image as IFilePath);
  };

  return (
    <Flex vertical gap={16}>
      <div className='file-list'>
        {files.map((file) => (
          <div key={file.id}>
            {loading ? (
              <Flex gap={10}>
                <Skeleton.Avatar active size={65} shape='square' />
                <Skeleton paragraph={{ rows: 1 }} title={{ width: '100%' }} />
              </Flex>
            ) : (
              <div className='file-list-item' key={file.id}>
                <Dropdown
                  menu={{
                    items: [
                      {
                        key: '1',
                        label: <li onClick={() => handleScrollToOrigin(file.topicDetailId)}>Xem tin nhắn gốc</li>
                      },
                      {
                        key: '2',
                        label: <li onClick={() => handleDownload(file)}>Tải về máy</li>
                      }
                    ]
                  }}
                  trigger={['click']}
                  placement='top'
                >
                  <Button className='media-action' size='small' icon={<Icon url={More} size={15} />} />
                </Dropdown>
                <MessageImageContainer file={file as IFilePath} key={file.id} className='file-item' />
              </div>
            )}
          </div>
        ))}
      </div>
      {filesData.length > LIMIT &&
        (!isShow ? (
          <Button block onClick={handleShowAll} className='btn-show'>
            Xem tất cả
          </Button>
        ) : (
          <Button block onClick={handleShowLess} className='btn-show'>
            Thu gọn
          </Button>
        ))}
    </Flex>
  );
}
